module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-apache-02-m-jp.6dbd8df8b44011944eec64ee07167d6a.png";